import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  BulkProduceTypeEnum,
  productionUiDisplayStateSelector,
  translateInfoItem,
} from "@ryde/shared";

import { ProductionPreviewStatistics } from "./production-preview-statistics";

interface IProductionPreviewResultProps {
  isStarted: boolean;
  action: BulkProduceTypeEnum;
}

export const ProductionPreviewResult: FC<IProductionPreviewResultProps> = ({
  isStarted,
  action,
}) => {
  const { t } = useTranslation();

  const { isFinished, error } = useRecoilValue(
    productionUiDisplayStateSelector,
  );

  return (
    <>
      {Boolean(isFinished && isStarted && !error) && (
        <ProductionPreviewStatistics action={action} />
      )}
      {isStarted && error && (
        <div className="production-preview__label--red">
          {translateInfoItem(error, t)}
        </div>
      )}
    </>
  );
};
